import React, { useState, useEffect } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import { addDays, getDiffBtnDates } from "../../utils/dateCalculater";

const GraphChart = ({ anltcs }) => {
  const [sortAnltcs, setSortAnltcs] = useState([]);

  const [graphView, setGraphView] = useState("daily");

  const heandelGraphView = (view) => {
    setGraphView(view);
  };

  // const [sortAnltcs, setSortAnltcs] = useState([]);
  let [apiHit, setApiHit] = useState({
    catagry: [],
    data: [],
  });

  const setUpChart = async () => {
    if (graphView === "weekly") {
      let firstDate = sortAnltcs ? sortAnltcs[0].key : "";
      let lastDate = sortAnltcs ? sortAnltcs[sortAnltcs.length - 1].key : "";
      let totalWeeks = await getDiffBtnDates(firstDate, lastDate);
      if (totalWeeks % 1 !== 0) {
        totalWeeks = parseInt(totalWeeks.toFixed(0)) + 1;
      }
      let key = [];
      let value = [];
      let getNtHitsPrDay = [...sortAnltcs];

      let dateOne = firstDate;
      for (let i = 0; i <= totalWeeks; i++) {
        // Get first Date and adding seven days of getNtHitsPrDay araay
        let seventhDay = await addDays(dateOne, 6);

        let customData = getNtHitsPrDay.filter((date) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });

        if (customData.length > 0) {
          let totalVal = 0;
          for (let j = 0; j < customData.length; j++) {
            totalVal += parseInt(customData[j].val);
          }
          value.push(parseInt(totalVal));
        } else {
          if (moment(dateOne).format("YYYY-MM-DD") <= lastDate) {
            value.push(0);
          }
        }
        if (moment(dateOne).format("YYYY-MM-DD") <= lastDate) {
          key.push(
            `${moment(dateOne).format("YYYY-MM-DD")} to ${moment(
              seventhDay
            ).format("YYYY-MM-DD")}`
          );
        }
        dateOne = await addDays(seventhDay, 1);
      }

      if (key.length > 0 || value.length > 0) {
        setApiHit({
          catagry: key,
          data: value,
        });
      }
    } else {
      let key = [];
      let value = [];
      sortAnltcs.forEach((api) => {
        key.push(api.key);
        value.push([moment(api.key).format("x"), parseInt(api.val)]);
      });
      if (key.length > 0 || value.length > 0) {
        setApiHit({
          catagry: key,
          data: value,
        });
      }
    }
  };

  useEffect(() => {
    if (anltcs && anltcs.ntHitsPrDay) {
      let sortedData = anltcs.ntHitsPrDay.sort(function (a, b) {
        return new Date(a.key) - new Date(b.key);
      });
      setSortAnltcs(sortedData);
    } else {
      setSortAnltcs([]);
      setApiHit({
        catagry: [],
        data: [],
      });
    }
  }, [anltcs]);

  useEffect(() => {
    if (sortAnltcs && sortAnltcs.length > 0) {
      setUpChart(sortAnltcs);
    }
  }, [sortAnltcs, graphView]);

  const options = {
    chart: {
      type: "area",
      height: "300px",
    },
    accessibility: {
      description:
        "Image description: An area chart compares the nuclear stockpiles of the USA and the USSR/Russia between 1945 and 2017. The number of nuclear weapons is plotted on the Y-axis and the years on the X-axis. The chart is interactive, and the year-on-year stockpile levels can be traced for each country. The US has a stockpile of 6 nuclear weapons at the dawn of the nuclear age in 1945. This number has gradually increased to 369 by 1950 when the USSR enters the arms race with 6 weapons. At this point, the US starts to rapidly build its stockpile culminating in 32,040 warheads by 1966 compared to the USSR’s 7,089. From this peak in 1966, the US stockpile gradually decreases as the USSR’s stockpile expands. By 1978 the USSR has closed the nuclear gap at 25,393. The USSR stockpile continues to grow until it reaches a peak of 45,000 in 1986 compared to the US arsenal of 24,401. From 1986, the nuclear stockpiles of both countries start to fall. By 2000, the numbers have fallen to 10,577 and 21,000 for the US and Russia, respectively. The decreases continue until 2017 at which point the US holds 4,018 weapons compared to Russia’s 4,500.",
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },

    xAxis: {
      allowDecimals: false,
      labels: {
        formatter: function () {
          if (this.value.includes("to")) {
            let splitVal = this.value.split("to");
            console.log(splitVal);
            return `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
              splitVal[1]
            ).format("DD MMM 'YY")}`;
          } else {
            return moment(this.value).format("DD MMM 'YY"); // clean, unformatted number for year
          } // clean, unformatted number for year
        },
      },
      categories: [...apiHit.catagry],

      // accessibility: {
      //   rangeDescription: "Range: Jan to Jun.",
      // },
    },
    yAxis: {
      title: null,
      labels: {
        formatter: function () {
          let val = this.value;
          if (val >= 10000000) {
            val = (val / 10000000).toFixed(0) + "Cr";
          } else if (val >= 100000) {
            val = (val / 100000).toFixed(0) + "L";
          } else if (val >= 1000) {
            val = (val / 1000).toFixed(0) + "K";
          }
          return val;
        },
      },
    },
    tooltip: {
      formatter: function () {
        let tooltipVal = "";
        if (this.x.includes("to")) {
          let splitVal = this.x.split("to");
          tooltipVal = `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
            splitVal[1]
          ).format("DD MMM 'YY")}`;
        } else {
          tooltipVal = moment(this.x).format("DD MMM 'YY");
        }
        return `<b>
        <div>${tooltipVal} </div> 
        </br>
        <div style="color:${this.series.color}">Api hits</div> : ${this.y} 
        </b>`;
      },
      borderWidth: 0,
      backgroundColor: "#fff",
      borderRadius: 4,
    },
    plotOptions: {
      series: {
        color: "#1c9ad6",
        fillColor: {
          linearGradient: [0, 0, 0, 250],
          stops: [
            [0, Highcharts.getOptions().colors[0]],
            [
              1,
              Highcharts.Color(Highcharts.getOptions().colors[0])
                .setOpacity(0)
                .get("rgba"),
            ],
          ],
        },
      },
      area: {
        marker: {
          enabled: true,
          symbol: "circle",
          radius: 2,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
    },
    series: [
      {
        name: null,
        data: [...apiHit.data],
        showInLegend: false,
      },
    ],
  };

  return (
    <>
      {sortAnltcs.length > 0 && (
        <div className="row5 border_bottom">
          <div className="chartSection">
            <div className="head display-space-between">
              <div>
                <h6>No. of API Hits</h6>
              </div>
              <div className="period">
                <button
                  className={
                    graphView === "daily"
                      ? "light-blue-btn pointer active"
                      : "light-blue-btn pointer"
                  }
                  onClick={() => heandelGraphView("daily")}
                >
                  Daily
                </button>

                <button
                  className={
                    graphView === "weekly"
                      ? "light-blue-btn pointer active"
                      : "light-blue-btn pointer"
                  }
                  onClick={() => heandelGraphView("weekly")}
                >
                  Weekly
                </button>
              </div>
            </div>
            <div className="GraphChart">
              <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GraphChart;
